import { AdminCalendarIcon } from "../AscIcons";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import classNames from "classnames";
import styles from "./AscMessageContent.module.scss";
import { AscImageSource } from "@ascendnow/shared";
import AscImage from "../AscImage/AscImage";

export interface AscMessageContentProps {
  className?: string;
  imageUrl?: AscImageSource;
  name: string;
  position: string;
  status: string;
  date: string;
  title: string;
  text?: string;
}

export default function AscMessageContent({
  className,
  imageUrl,
  name,
  position,
  status,
  date,
  title,
  text,
}: AscMessageContentProps) {
  return (
    <div
      data-testid="asc-message-content"
      className={classNames(styles.ground, className)}
    >
      <div className={styles.topGround}>
        {imageUrl ? (
          <AscImage src={imageUrl} alt={""} className={styles.image} />
        ) : (
          <div className={styles.noImage} />
        )}

        <div className={styles.content}>
          <div className={styles.contentTop}>
            {name}{" "}
            <span
              className={classNames(styles.position, {
                [styles.student]: position === "Student",
                [styles.parent]: position === "Parent",
              })}
            >
              {position}
            </span>
          </div>
          <div className={styles.contentBottom}>
            <div
              className={classNames(styles.circle, {
                [styles.green]: status === "Sent",
                [styles.yellow]: status === "Inbox",
              })}
            />{" "}
            {status}
          </div>
        </div>

        <div className={styles.date}>
          <AdminCalendarIcon className={styles.iconCalendar} />
          {date}
        </div>
      </div>

      <AscHeading className={styles.title} level={6}>
        {title}
      </AscHeading>

      <hr className={styles.hr} />

      <form className={styles.inputGround}>
        <textarea className={classNames(styles.inputText)} value={text} />
      </form>
    </div>
  );
}
